<template>
  <el-card
    id="myLGACard"
    v-loading="loading"
    shadow="hover"
    class="clear-card myLGA"
    :body-style="{boxSizing: 'border-box', height: 'calc(100% - 59px)'}"
    :class="$mq"
  >
    <div
      slot="header"
      class="clearfix title"
    >
      <span>{{ $mq === 'desktop' ? $t('lga.myLgaLong') : $t('lga.myLgaShort') }}</span>
    </div>
    <div
      class="content"
      :class="['mobile', 'tablet'].includes($mq) ? 'mobileContent' : 'content'"
    >
      <div
        v-if="!previewMode && lgas && (lgas.lga1 || lgas.lga2) && lgas.status === 'published'"
        class="lgas defaultCursor"
        :class="['mobile', 'tablet'].includes($mq) ? 'mobileLgas' : ''"
      >
        <div v-if="lgas.lga1">
          <span>{{ lgas.lga1 }}</span>
        </div>
        <div v-if="lgas.lga2">
          <span>{{ lgas.lga2 }}</span>
        </div>
      </div>

      <div
        v-else
        class="no-data defaultCursor"
      >
        <i>{{ $t('lga.noData') }}</i>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      loading: (state) => state.myLGAs.loading,
      lgas: (state) => state.myLGAs.lgas,
    }),
  },
};
</script>

<style lang="scss" scoped>
  #myLGACard {
    height: 100%;

    .title,
    .titleMobile {
      text-align: center;
    }

    &:not(.mobile):not(.tablet) {
      border-radius: 0;
    }

    .content {
      text-align: center;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .lgas {
        color: var(--themeFontColor);
        font-weight: bold;
        font-size: 20px;
        word-break: break-word;

        & > div:first-child {
          margin-bottom: 20px;
        }
      }

      .no-data {
        color: #c4c4c4;
        font-style: italic;
      }
    }
  }
</style>

<style lang="scss">
  #myLGACard {
    .el-card__header {
      font-weight: bold;
      padding-left: 0;
      padding-right: 0;
    }

    &.mobile,
    &.tablet {
      .el-card__header {
        border-bottom: 0;
      }

      .el-card__body {
        padding-top: 5px;

        .mobileContent {
          .mobileLgas {
            font-weight: normal !important;
          }
        }
      }
    }
  }
</style>
